export function getSiteKey() {
  return process.env.GOOGLE_RECAPTCHA_SITE_KEY;
}
export function isRecaptchaProviderDefined(context) {
  var _ref = context || {},
    executeRecaptcha = _ref.executeRecaptcha;
  if (!executeRecaptcha) {
    // case in which the RecaptchaProvider has been defined but yet not loaded
    return true;
  }
  if (executeRecaptcha.length === 1) {
    // case in which the RecaptchaProvider has been defined and loaded
    return true;
  }
  // RecaptchaProvider not yet defined nor loaded
  return false;
}
export function isRecaptchaProviderLoaded(context) {
  var _ref2 = context || {},
    executeRecaptcha = _ref2.executeRecaptcha;
  if (!executeRecaptcha) {
    return false;
  }
  if (executeRecaptcha.length === 1) {
    return true;
  }
  return false;
}
export function isRecaptchaInjectedInDom() {
  if (typeof window === 'undefined') {
    return false;
  }
  var _window = window,
    grecaptcha = _window.grecaptcha;
  if (!grecaptcha) {
    return false;
  }
  var badge = document.getElementsByClassName('grecaptcha-badge');
  return !!grecaptcha.enterprise && !!grecaptcha.enterprise.execute && badge.length >= 1;
}